import { ColDef } from "ag-grid-community/dist/lib/entities/colDef";
import { ICellRendererParams } from "ag-grid-community/dist/lib/rendering/cellRenderers/iCellRenderer";
import { StyledInputCell, Style } from "./style";
import { useFormikContext } from "formik";
import { memo, useEffect, useRef, useState } from "react";
import { debounce, get } from "lodash";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Form } from "antd";
import { getRuleValidation } from "@lhd/components/CloneApp/fieldUtils";
interface IProps {
  isDisabled?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  namePath: string | string[];
  styleColor?: React.CSSProperties;
}
const TextAreaCustom = (props: IProps) => {
  const { namePath, isDisabled, item } = props;
  const form = Form.useFormInstance();
  const refTextArea = useRef<HTMLTextAreaElement>(null);

  return (
    <Style className={`${isDisabled ? "ant-input-disabled" : ""} ant-input `}>
      <Form.Item name={namePath} rules={getRuleValidation(item)}>
        <StyledInputCell
          disabled={isDisabled}
          ref={refTextArea}
          onBlur={(e) => {
            const value = e.target.value;
            const trimmedValue = value.trim();

            if (value !== trimmedValue) {
              form.setFieldValue(namePath, trimmedValue);
            }
          }}
        />
      </Form.Item>
    </Style>
  );
};

export default memo(TextAreaCustom);
